export const dadataApiKey = '074496d54a124e6494b9fc66d04f4b8f7ff7ae2e'
